import { css } from "emotion";
import CMSComponent from "../../../components/CMSComponent";
import H2 from "../../../components/global/H2";
import P from "../../../components/global/P";
import Banner from "../../../components/layout/Banner";
import Layout from "../../../components/layout/Layout";
import { updateTitle } from "../../../utils/BrowserUtils";
import DescriptionBlock from "../DescriptionBlock";
import Flag from "./componets/Flag";
import HowToHelp from "./componets/HowToHelp";
import HowWeDeliver from "./componets/HowWeDeliver";
import OurImpacts from "./componets/OurImpacts";
import ProjectDeliveryPartners from "./componets/ProjectDeliveryPartners";
import Quote from "./componets/Quote";

const icPathwaySupport = require("../../../assets/Projects/ic_full_scholarship.svg");
const icFullScholarship = require("../../../assets/Projects/ic_pathway_support.svg");
const vanessaLee = require("../../../assets/Projects/Vanessa_Lee.png");
const yalariLogo = require("../../../assets/Projects/yalari_logo.png");
const bannerImage = require("../../../assets/Projects/YalariBanner.png");
const partnerLogo = require("../../../assets/logo_yalari.png");
const issue = require("../../../assets/Projects/Yalari.png");

const bannerContent = css({
  padding: "0px 0px 0px 80px",
  textAlign: "left",
  h2: {
    maxWidth: 421,
    marginBottom: 16,
    fontSize: 36
  },
  p: {
    maxWidth: 421,
    marginBottom: 20,
    marginLeft: 0,
    fontSize: 16
  },
  "@media(max-width: 1080px)": {
    padding: "112px 0px 24px 80px"
  },
  "@media(max-width: 768px)": {
    padding: "40px 14px 24px 14px",
    h2: {
      fontSize: 22
    },
    p: {
      fontSize: 16
    }
  }
});

const impactsObj = [
  {
    title: "Every ticket counts",
    content: "$54 = 1 day",
    subtext: "scholarship to one of Australia's best schools"
  },
  {
    title: "Our impact",
    content: "1,700 days",
    subtext: "days of scholarships"
  },
  {
    title: "Our target",
    content: "10 million",
    subtext: "days of scholarship by 2030"
  }
];

const howWeDeliverScholarship = [
  {
    image: icFullScholarship,
    alt: "Full Scholarship icon",
    title: "Full scholarship to top schools",
    content:
      "Students from regional, rural or remote communities apply for the scholarship, which covers tuition, boarding, books and uniforms."
  },
  {
    image: icPathwaySupport,
    alt: "Pathways and Support icon",
    title: "Pathways and Support",
    content:
      "The students receive career guidance, work experience and support post-school to aid in the transition to higher education, vocational training and employment."
  }
];

const Yalari = ({ localeData }) => {
  updateTitle("Yalari");
  const consoleUrl =
    localeData && localeData.consoleURL ? localeData.consoleURL : "";

  //our impact

  //the issue
  const explanation = [
    "Indigenous students face many unique challenges that have made education gaps difficult to close. Those in regional, rural and remote communities in particular have to contend with geographic barriers, with only 24% of these students having access to a school that offers study to Year 12.",
    "Whilst there has been improvements over the years, these structural challenges have seen the Year 12 attainment rates for Indigenous Australians remain over 27% below non-Indigenous Australians. Together let’s help close this gap."
  ];

  return (
    <Layout>
      <Banner
        image={bannerImage}
        bgColor="greyBackground"
        alt="Group of boys smiling in school uniform"
      >
        <div className={bannerContent}>
          <H2>Indigenous Scholarships</H2>
          <P>
            Only 65% of Aboriginal and Torres Strait Islander students complete
            year 12, so we’re funding scholarships so that every student has an
            equal chance.
          </P>
        </div>
      </Banner>

      <OurImpacts data={impactsObj} />

      <DescriptionBlock
        heading={
          <span>
            This education gap <i>must</i> be closed
          </span>
        }
        alt="Three smiling girls in school uniforms"
        image={issue}
        text={explanation}
      />

      <HowWeDeliver
        header="How we deliver our scholarship program"
        data={howWeDeliverScholarship}
      />

      <HowToHelp
        localeData={localeData}
        text="We’re a unique charity, in that we don’t ask for donations (though you are welcome to offer). "
      />

      <ProjectDeliveryPartners image={partnerLogo} imageAlt="OzHarvest Logo">
        <P>
          We believe in impact with evidence, not just good intentions. That’s
          why we work with expert delivery partners, to make sure all our
          projects are making long lasting, systemic change.
        </P>
        <Flag>
          <img src={partnerLogo} alt="Yalari logo" />
          <P>
            Our scholarship program is delivered in partnership with Yalari’s
            network of 24 partner schools.
          </P>
        </Flag>
        <Quote
          image={vanessaLee}
          imageAlt="Picture of Dr Vanessa Lee."
          quote="“Education is an opportunity for our mobs to support and promote families to participate in life autonomy, take control of their opportunities and create a platform for the next generation to enhance their wellbeing.”"
          author="Dr Vanessa Lee, University of Sydney academic"
        />
      </ProjectDeliveryPartners>
    </Layout>
  );
};

export default CMSComponent(null, Yalari);
